// removed by extract-text-webpack-plugin
module.exports = {"container":"container-2QZ60","header":"header-1LWur","headerText":"headerText-3S5kJ","viewAll":"viewAll-2CV_m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/courses/_recentCourses.css
// module id = 1208
// module chunks = 1